import { useTranslation } from 'react-i18next';
import { Flex, Icon, spaces, Text, Tooltip } from '@electricjs/arc';

type RestrictedEmployeeProps = {
  /** Replaces the default visible text. */
  label?: string;
  /** Replaces the default hover text. */
  tooltip?: string;
  /** Flows inside a sentence instead of taking its own line. */
  inline?: boolean;
  bold?: boolean;
  /** How many hidden employees this stands for; only changes the tooltip wording. */
  count?: number;
};

/** Shown in place of an employee the user can't see (outside their divisions). */
export const RestrictedEmployee = ({
  label,
  tooltip,
  inline,
  bold,
  count,
}: RestrictedEmployeeProps) => {
  const { t } = useTranslation('common');

  return (
    <Tooltip
      content={
        tooltip ?? t('restrictedEmployee.tooltip', { count: count ?? 1 })
      }
      placement="top"
      // Arc's Tooltip forwards its inline-block display to the child, which would
      // stack the label and the lock instead of keeping them on one line.
      display={inline ? 'inline-flex' : 'flex'}>
      <Flex alignItems="center" display={inline ? 'inline-flex' : undefined}>
        <Text variant="body-2" fontWeight={bold ? 'bold' : undefined}>
          {label ?? t('restrictedEmployee.label')}
        </Text>
        <Icon
          icon="lock"
          size="small"
          ml={inline ? spaces.space_2xs : spaces.space_xs}
          data-testid="restricted-icon"
        />
      </Flex>
    </Tooltip>
  );
};
